"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiDropWithoutWave } from "@/generated/models/ApiDropWithoutWave";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { toApiWaveMin } from "@/helpers/waves/wave.helpers";
import { generateUniqueKeys, mapToExtendedDrops } from "@/helpers/waves/wave-drops.helpers";
import { fetchWaveCurationDropsV2 } from "@/services/api/wave-curation-drops-v2-api";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export function useWaveCurationPreviewDrops(t0) {
  const $ = _c(25);
  const {
    wave,
    curationId,
    pageSize,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== curationId) {
    t2 = curationId?.trim() ?? "";
    $[0] = curationId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const normalizedCurationId = t2;
  const waveId = wave?.id ?? null;
  let t3;
  if ($[2] !== wave) {
    t3 = wave ? toApiWaveMin(wave) : null;
    $[2] = wave;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const waveMin = t3;
  const t4 = normalizedCurationId || null;
  let t5;
  if ($[4] !== pageSize || $[5] !== t4 || $[6] !== waveId) {
    t5 = [QueryKey.DROPS, {
      waveId,
      curationId: t4,
      pageSize,
      context: "wave-curation-preview-drops"
    }];
    $[4] = pageSize;
    $[5] = t4;
    $[6] = waveId;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const queryKey = t5 as const;
  let t6;
  if ($[8] !== normalizedCurationId || $[9] !== pageSize || $[10] !== wave) {
    t6 = async t7 => {
      const {
        signal
      } = t7;
      if (!wave || !normalizedCurationId) {
        throw new Error("Wave and curation are required to load curation preview drops");
      }
      return await fetchWaveCurationDropsV2({
        wave,
        curationId: normalizedCurationId,
        page: 1,
        pageSize,
        signal
      });
    };
    $[8] = normalizedCurationId;
    $[9] = pageSize;
    $[10] = wave;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = enabled && !!waveId && normalizedCurationId.length > 0;
  let t8;
  if ($[12] !== queryKey || $[13] !== t6 || $[14] !== t7) {
    t8 = {
      queryKey,
      queryFn: t6,
      enabled: t7,
      staleTime: 120000,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false
    };
    $[12] = queryKey;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const {
    data,
    error,
    isError,
    isFetching
  } = useQuery(t8);
  let t9;
  bb0: {
    if (!waveMin || !data) {
      let t10;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [];
        $[16] = t10;
      } else {
        t10 = $[16];
      }
      t9 = t10;
      break bb0;
    }
    let t10;
    if ($[17] !== data.data || $[18] !== waveMin) {
      t10 = generateUniqueKeys(mapToExtendedDrops([{
        wave: waveMin,
        drops: data.data as ApiDropWithoutWave[]
      }], [], false), []);
      $[17] = data.data;
      $[18] = waveMin;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    t9 = t10;
  }
  const drops = t9;
  let t10;
  if ($[20] !== drops || $[21] !== error || $[22] !== isError || $[23] !== isFetching) {
    t10 = {
      drops,
      error,
      isError,
      isFetching
    };
    $[20] = drops;
    $[21] = error;
    $[22] = isError;
    $[23] = isFetching;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}